import { lazy } from 'react';
import { Platform } from 'react-native';
import { isMobileLayout } from '../../../components/styles/responsive';
import { wrapNavigatorScreen } from '../../../functions/navigation/utils/wrapNavigatorScreen';

const DeleteMyAccountPageContent = lazy(
  () => import('./DeleteMyAccountPageContent'),
);

export const DeleteMyAccountPage = wrapNavigatorScreen(
  DeleteMyAccountPageContent,
  {
    title: 'Delete Account',
    headerShown: Platform.OS !== 'web' && isMobileLayout(),
  },
);
